import { NSARouterMakerResult } from "namirasoft-account-react";
import { useRef } from "react";
import { Link } from "react-router-dom";
import { NSBoxEmail, NSBoxEntity, NSLine, NSLineText, NSRow } from 'namirasoft-site-react';
import { NSBoxPhone } from 'namirasoft-site-react';
import { NSBoxDate } from 'namirasoft-site-react';
import { NSButtonBlue } from 'namirasoft-site-react';
import { NSBoxString } from 'namirasoft-site-react';
import { AccountLayout } from "../AccountLayout";
import { NSSection, NSSpace, NSSpaceSizeType, NSBoxSensitive } from "namirasoft-site-react";
import { AccountRoutes } from "../AccountRoutes";
import { NSPanel } from 'namirasoft-site-react';
import { Country, TimeOperation } from "namirasoft-core";
import { AccountGithubLogin } from "../components/AccountGithubLogin";
import { AccountGoogleLogin } from "../components/AccountGoogleLogin";

interface RegisterPageProps extends NSARouterMakerResult
{ }

function RegisterPage(props: RegisterPageProps) 
{
    const NSBoxString_FirstName = useRef<NSBoxString>(null);
    const NSBoxString_LastName = useRef<NSBoxString>(null);
    const NSBoxEmail_Email = useRef<NSBoxEmail>(null);
    const NSBoxPhone_Phone = useRef<NSBoxPhone>(null);
    const NSInputSelectBox_Country = useRef<NSBoxEntity<Country>>(null);
    const NSBoxDate_Birthday = useRef<NSBoxDate>(null);
    const NSBoxSensitive_Password = useRef<NSBoxSensitive>(null);
    const NSBoxSensitive_Confirm_Password = useRef<NSBoxSensitive>(null);

    function onRegister(onFinished: () => void)
    {
        try
        {
            let first_name: string = NSBoxString_FirstName.current?.getValue() ?? "";
            let last_name: string = NSBoxString_LastName.current?.getValue() ?? "";
            let email: string = NSBoxEmail_Email.current?.getValue() ?? "";
            let phone: string = NSBoxPhone_Phone.current?.getValue() ?? "";
            let country: string = NSInputSelectBox_Country.current?.getValueOne() ?? "";
            let _birthday: Date | null = NSBoxDate_Birthday.current?.getValue() ?? null;
            let birthday: string | null = _birthday ? TimeOperation.format(_birthday, "yyyy-MM-DD") : null;
            let password: string = NSBoxSensitive_Password.current?.getValue() ?? "";
            let password_confirm: string = NSBoxSensitive_Confirm_Password.current?.getValue() ?? "";

            if (password === password_confirm)
            {
                props.account.server.user.Register({ first_name, last_name, country, email, phone, birthday, password }).then(() =>
                {
                    props.url.redirect(AccountRoutes.Home, {});
                    onFinished();
                }).catch(onFinished);
            }
            else
                throw new Error("The password and the confirmation must match.");
        } catch (error)
        {
            props.notifier.onError(error as Error);
            onFinished();
        }
    }

    return (
        <AccountLayout {...props}
            title={{
                title: 'Register',
                description: 'Provide some information to register for a Namirasoft Account, to access exclusive features and other associated products and services.'
            }}
            onEnterPressed={() =>
            {
                onRegister(() => { });
            }}
        >
            <NSSection>
                <NSPanel>
                    <NSRow>
                        <NSBoxString
                            required={true}
                            title="First Name"
                            ref={NSBoxString_FirstName}
                        />
                        <NSBoxString
                            required={true}
                            title="Last Name"
                            ref={NSBoxString_LastName}
                        />
                    </NSRow>
                    <NSRow>
                        <NSBoxEmail
                            ref={NSBoxEmail_Email}
                            title="Email"
                            required={true}
                            menu={{
                                builtin: {
                                    email: false
                                },
                                items: []
                            }}
                        />
                        <NSBoxEntity<Country>
                            ref={NSInputSelectBox_Country}
                            title="Country"
                            required
                            multiple={false}
                            table_name="country"
                            list={async () =>
                            {
                                let countries = await props.account.server.country.List();
                                return { count: countries.length, rows: countries };
                            }}
                            getValue={c => { return c.iso3; }}
                            getTitle={c => { return c.name; }}
                            getSort={() => { return null; }}
                        />
                    </NSRow>
                    <NSRow>
                        <NSBoxDate
                            required={true}
                            title="Birthday"
                            ref={NSBoxDate_Birthday}
                        />
                        <NSBoxPhone
                            required={true}
                            title="Phone"
                            ref={NSBoxPhone_Phone}
                        />
                    </NSRow>
                    <NSRow>
                        <NSBoxSensitive
                            required={true}
                            title="Password"
                            ref={NSBoxSensitive_Password}
                        />
                        <NSBoxSensitive
                            required={true}
                            title="Confirm Password"
                            ref={NSBoxSensitive_Confirm_Password}
                        />
                    </NSRow>
                </NSPanel>
                <NSSpace size={NSSpaceSizeType.NORMAL}></NSSpace>
                <NSButtonBlue
                    title="Register"
                    onClick={{
                        action: (onFinished) =>
                        {
                            onRegister(onFinished)
                        }
                    }} />
                <NSSpace size={NSSpaceSizeType.SMALL}></NSSpace>
                <NSLineText title="OR" />
                <NSSpace size={NSSpaceSizeType.SMALL}></NSSpace>
                <AccountGoogleLogin {...props} />
                <NSSpace size={NSSpaceSizeType.SMALL}></NSSpace>
                <AccountGithubLogin {...props} />
                <NSSpace size={NSSpaceSizeType.SMALL}></NSSpace>
                <NSLine />
                <NSSpace size={NSSpaceSizeType.SMALL}></NSSpace>
                <p className={`nsa-font-16-bold m-0 nsa-color-blue-dark `}>
                    Do you have already an account?
                    <Link className="nsa-color-blue ms-1" to={props.url.getLink(AccountRoutes.Login, [])}>
                        Login
                    </Link>
                </p>
            </NSSection>
        </AccountLayout>
    );
}

export default RegisterPage;